import React, { useState, useEffect } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Upload, message } from "antd";
import { useNavigate, useParams } from "react-router";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const AdminUpdateNotice = () => {
  const [fileList, setFileList] = useState([]);
  const [currentImage, setCurrentImage] = useState("");
  const [content, setContent] = useState(""); // Quill içeriğini tutacak state
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id: noticeId } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/notice/${noticeId}`);
        if (response.ok) {
          const data = await response.json();
          form.setFieldsValue({
            title: data.title || "",
          });
          setContent(data.content || ""); // ReactQuill için içeriği set et
          setCurrentImage(data.img || "");
        } else {
          message.error("Duyuru bilgisi alınamadı!");
        }
      } catch (error) {
        console.error(error);
        message.error("Sunucudan yanıt alınamadı.");
      }
    };

    fetchNotice();
  }, [noticeId, form, apiUrl]);

  const normFile = (e) => (Array.isArray(e) ? e : e && e.fileList);

  const handleFileChange = ({ fileList }) => setFileList(fileList);

  const handleSubmit = async (values) => {
    const { title } = values;

    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content); // ReactQuill içeriğini ekliyoruz

    if (fileList.length > 0 && fileList[0].originFileObj) {
      formData.append("img", fileList[0].originFileObj);
    } else {
      formData.append("existingImg", currentImage);
    }

    try {
      const response = await fetch(`${apiUrl}/api/notice/${noticeId}`, {
        method: "PUT",
        body: formData,
      });

      if (response.ok) {
        message.success("Duyuru başarıyla güncellendi!");
        navigate("/admin/notice");
      } else {
        message.error("Bir hata oluştu.");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Sunucu hatası oluştu.");
    }
  };

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 14 }}
      layout="horizontal"
      onFinish={handleSubmit}
      style={{ maxWidth: 800, margin: "0 auto" }}
    >
      <Form.Item
        label="Başlık"
        name="title"
        rules={[{ required: true, message: "Lütfen başlık giriniz!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item label="Duyuru İçeriği" required>
        <ReactQuill
          theme="snow"
          value={content}
          onChange={setContent}
          modules={{
            toolbar: [
              [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
              [{ size: [] }],
              ['bold', 'italic','blockquote'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              ['link'],
              ['clean']
            ],
          }}
        />
      </Form.Item>

      <Form.Item label="Resim" name="img">
        <Upload
          listType="picture-card"
          fileList={fileList}
          onChange={handleFileChange}
          beforeUpload={() => false}
        >
          {fileList.length === 0 && (
            <button style={{ border: 0, background: "none" }} type="button">
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>Upload</div>
            </button>
          )}
        </Upload>
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 4, span: 14 }}>
        <Button type="primary" htmlType="submit">
          Duyuru Güncelle
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AdminUpdateNotice;
